import { serverAjaxPromise } from './request_helpers';

const addToList = (listId, type, objectId, userId) => {
  const params = {
    object_id: objectId,
    type,
    include_obj: true
  };
  // Defaults request to updating own list unless a user id is specified
  if (userId) {
    params.user_id = userId;
  }
  return serverAjaxPromise({
    type: 'POST',
    url: `/api/alltrails/v2/lists/${listId}/items`,
    data: params,
    resReducer: data => data.listItems[0]
  });
};

const removeFromList = (listId, listItemId, userId) => {
  const params = {};
  // Defaults request to updating own list unless a user id is specified
  if (userId) {
    params.user_id = userId;
  }
  return serverAjaxPromise({
    type: 'DELETE',
    url: `/api/alltrails/v2/lists/${listId}/items/${listItemId}`,
    data: params,
    resReducer: data => data.listItems[0]
  });
};

const reorderList = (listId, orderedListItemIds) => {
  if (!orderedListItemIds || orderedListItemIds.length < 1) {
    return Promise.resolve([]);
  }
  return serverAjaxPromise({
    type: 'PUT',
    url: `/api/alltrails/v2/lists/${listId}/reorder`,
    data: {
      ordered_list_item_ids: orderedListItemIds
    },
    resReducer: data => data.listItems
  });
};

const copyList = listId => {
  return serverAjaxPromise({
    type: 'POST',
    url: `/api/alltrails/lists/${listId}/copy`,
    resReducer: data => data.lists[0]
  });
};

export { addToList, removeFromList, reorderList, copyList };
